import React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  TextField,
  Grid,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import { isNil } from 'lodash';
import { Typography } from '@material-ui/core';
import { CHOICE } from 'containers/PreOpeningPage/constants';
import CloseIcon from '@material-ui/icons/Close';
import { StyledDialog } from 'components/InvoiceFeeNoteDialog/styles';
import { translate } from 'containers/services/translate';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import messages from 'components/InvoiceFeeNoteDialog/messages';

export interface InvoiceFeeNoteDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  decisionGenerationFeeNote: any;
  setDecisionGenerationFeeNote: Function;
  handleValidate: Function;
  shouldDisplayFirmReferenceField: boolean;
  setLawyerFirmRef: Function;
  lawyerFirmRef: any;
}

const InvoiceFeeNoteDialog: React.FC<InvoiceFeeNoteDialogProps> = (
  props,
): JSX.Element => {
  const { onClose, open } = props;

  const handleClose = () => {
    onClose(false);
  };

  const handleChange = (
    event: React.ChangeEvent<{
      name?: string;
      value?: unknown;
    }>,
  ) => {
    props.setDecisionGenerationFeeNote(event.target.value === CHOICE.YES);
  };

  const handleChangeField = (
    event: React.ChangeEvent<{
      name?: string;
      value?: unknown;
    }>,
  ) => {
    props.setLawyerFirmRef(event.target.value);
  };
  return (
    <StyledDialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="space-between"
        >
          <Grid item xs={9}>
            <span
              style={{
                color: '#172C51 !important',
                fontSize: '20px',
                lineHeight: '24.42px',
              }}
            >
              {translate(messages.titleDialog, props)}
            </span>
          </Grid>
          <Grid item>
            <CloseIcon onClick={handleClose} />
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Typography className="success-title">
          {translate(messages.subTitleDialog, props)}
        </Typography>
        <FormControl
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            marginTop: 15,
          }}
        >
          <RadioGroup
            row
            onChange={handleChange}
            value={
              !isNil(props.decisionGenerationFeeNote)
                ? props.decisionGenerationFeeNote
                  ? CHOICE.YES
                  : CHOICE.NO
                : null
            }
          >
            <FormControlLabel
              control={<Radio color="primary" value={CHOICE.YES} />}
              label={translate(messages.generateFeeNoteTitle, props)}
            />
            <FormControlLabel
              control={<Radio color="primary" value={CHOICE.NO} />}
              label={translate(messages.doNotGenerateFeeNoteTitle, props)}
            />
          </RadioGroup>
        </FormControl>
        <Grid style={{ marginTop: 20, width: '60%' }}>
          {props.shouldDisplayFirmReferenceField &&
            props.decisionGenerationFeeNote && (
              <TextField
                name="firm-reference"
                value={props.lawyerFirmRef}
                onChange={handleChangeField}
                label={translate(messages.firmReference, props)}
                style={{
                  width: '100%',
                }}
              />
            )}
        </Grid>
      </DialogContent>
      <DialogActions className="success-actions">
        <SecondaryButton
          onClick={() => props.onClose()}
          disableElevation
          data-testId="cancel-button"
          title={translate(messages.cancel, props)}
        />
        <PrimaryButton
          onClick={() => props.handleValidate()}
          disableElevation
          data-testId="validate-button"
          className="primary-button"
          title={translate(messages.confirm, props)}
          disabled={
            (props.shouldDisplayFirmReferenceField &&
              props.decisionGenerationFeeNote &&
              (isNil(props.lawyerFirmRef) || props.lawyerFirmRef === '')) ||
            isNil(props.decisionGenerationFeeNote)
          }
        />
      </DialogActions>
    </StyledDialog>
  );
};

export default injectIntl(InvoiceFeeNoteDialog);
